module.exports = __webpack_public_path__ + "img/shopping-cart.b73323f.svg";